export const alertInitialState = { showAlert: false, alertMessage: "", alertType: '' };

export const SHOW_SUCCESS_ALERT = "SHOW_SUCCESS_ALERT";
export const SHOW_ERROR_ALERT = "SHOW_ERROR_ALERT";
export const SHOW_INFO_ALERT = "SHOW_INFO_ALERT";
export const SHOW_WARNING_ALERT = "SHOW_WARNING_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

export const alertNotifierReducer = (state, { type, alertMessage }) => {
    switch (type) {
        case HIDE_ALERT:
            return { ...state, alertType: '', showAlert: false, alertMessage: "" };
        case SHOW_ERROR_ALERT:
            return { ...state, alertType: 'error', showAlert: true, alertMessage: alertMessage || "" };
        case SHOW_SUCCESS_ALERT:
            return { ...state, alertType: 'success', showAlert: true, alertMessage: alertMessage || "" };
        case SHOW_INFO_ALERT:
            return { ...state, alertType: 'info', showAlert: true, alertMessage: alertMessage || "" };
        case SHOW_WARNING_ALERT:
            return { ...state, alertType: 'warning', showAlert: true, alertMessage: alertMessage || "" };
        default:
            return state;
    }
};
